"use client";

import { createContext, useContext, type MouseEvent, type ReactNode } from "react";
import type { AppLinkRenderProps } from "../types";

export type AppNavContextValue = {
  pathname: string;
  renderLink?: (props: AppLinkRenderProps) => ReactNode;
  onNavLinkClick?: (href: string, event: MouseEvent<HTMLElement>) => void;
  onNavigate?: (href: string) => void;
};

const AppNavContext = createContext<AppNavContextValue>({
  pathname: "/",
});

export const AppNavProvider = ({
  children,
  pathname,
  renderLink,
  onNavLinkClick,
  onNavigate,
}: AppNavContextValue & { children: ReactNode }) => {
  return (
    <AppNavContext.Provider
      value={{ pathname, renderLink, onNavLinkClick, onNavigate }}
    >
      {children}
    </AppNavContext.Provider>
  );
};

export const useAppNav = () => useContext(AppNavContext);
